
const CellTLSalesConsultant: React.FC<{ data: any }> = ({ data }) => {
    return (
        <>{data['sales_consultant']},<br />{data['team_leader']}</>
    )
}

export default CellTLSalesConsultant;